<script setup>
import { computed } from "vue";

import { useTheme } from "@/composables/useTheme";
import theme from "@/lib/constants/theme.js";

const props = defineProps({
  imageClass: {
    type: String,
    default: "",
  },
  forceLightTheme: {
    type: Boolean,
    default: false,
  },
  disableLink: {
    type: Boolean,
    default: false,
  },
});

const { isDarkTheme: isDarkThemeFromStore, hasOnPremLogo } = useTheme();

const customThemeLogo = computed(() => theme?.assets?.logo);
const isOnPremWithLogo = computed(() => hasOnPremLogo.value);
const isDarkTheme = computed(() => {
  if (props.forceLightTheme) return false;
  return isDarkThemeFromStore.value;
});
</script>

<template>
  <div class="sns-logo">
    <component
      :is="disableLink ? 'div' : 'router-link'"
      :to="disableLink ? undefined : { name: 'dashboard.home' }"
      title="Sensity"
    >
      <img v-if="isOnPremWithLogo" :src="'/logo.svg'" class="w-full h-auto max-h-20" :class="imageClass" alt="logo" />
      <img
        v-else-if="customThemeLogo"
        :src="customThemeLogo"
        class="w-full h-auto max-h-20"
        :class="imageClass"
        alt="logo"
      />
      <img
        v-else-if="isDarkTheme"
        src="@/assets/images/logo_white.svg"
        class="w-3/5"
        :class="imageClass"
        alt="sensity-ai logo"
      />
      <img v-else src="@/assets/images/logo.svg" class="w-3/5" :class="imageClass" alt="sensity-ai logo" />
    </component>
  </div>
</template>
